export enum AppInstanceType {
    home,
    discovery,
    widgets,
    dashboard,
    security,
    datatypes,
    debugmode,
    dictionary,
    ingestion_management
}